import { useSubscription } from "@apollo/client";
import { useState } from "react";
import { useEffect } from "react";
import { API_CHARGER_COUNT } from "../../graphql/query";
import { Box, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import CustomModal from "../customComponents/customModal";
import CustomTabs from "../customComponents/CustomTabs";
import ExportExcel from "../buttonComponents/ExportExcel";
import DynamicTable from "../customComponents/DynamicTable";

const ChargerOperationStatus = ({ boxColor, facilityFilter }) => {
  const [chargerStatus, setChargerStatus] = useState(null);
  const { selectedFacility } = useSelector((state) => state.stationList);
  const { t } = useTranslation();

  const getEpochLastDate = (minus) => {
    const thedate = new Date();
    thedate.setDate(thedate.getDate() - minus);
    const seconds = Math.floor(thedate.getTime() / 1000);
    return Math.floor(seconds / 300) * 300; //interval 300 secs = 5 mins
  };

  const { data } = useSubscription(API_CHARGER_COUNT, {
    variables: {
      where: {
        _and: [
          {
            api_facility: {
              ...(selectedFacility?.id && {
                id: {
                  _in: [
                    ...(typeof selectedFacility?.id === "number"
                      ? [selectedFacility?.id]
                      : selectedFacility?.id),
                  ],
                },
              }),
            },
          },
          {
            api_chargerports: {
              api_chargersessions: {
                stop_at: {
                  _gte: getEpochLastDate(15).toString(),
                },
              },
            },
          },
        ],
      },
    },
  });
  const { data: data1 } = useSubscription(API_CHARGER_COUNT, {
    variables: {
      where: {
        _and: [
          {
            api_facility: {
              ...(selectedFacility?.id && {
                id: {
                  _in: [
                    ...(typeof selectedFacility?.id === "number"
                      ? [selectedFacility?.id]
                      : selectedFacility?.id),
                  ],
                },
              }),
            },
          },
          {
            api_chargerports: {
              api_chargersessions: {
                stop_at: {
                  _gte: getEpochLastDate(30).toString(),
                },
              },
            },
          },
        ],
      },
    },
  });
  const { data: data2 } = useSubscription(API_CHARGER_COUNT, {
    variables: {
      where: {
        _and: [
          {
            api_facility: {
              ...(selectedFacility?.id && {
                id: {
                  _in: [
                    ...(typeof selectedFacility?.id === "number"
                      ? [selectedFacility?.id]
                      : selectedFacility?.id),
                  ],
                },
              }),
            },
          },
          {
            api_chargerports: {
              api_chargersessions: {
                stop_at: {
                  _gte: getEpochLastDate(60).toString(),
                },
              },
            },
          },
        ],
      },
    },
  });
  const { data: data3 } = useSubscription(API_CHARGER_COUNT, {
    variables: {
      where: {
        _and: [
          {
            api_facility: {
              ...(selectedFacility?.id && {
                id: {
                  _in: [
                    ...(typeof selectedFacility?.id === "number"
                      ? [selectedFacility?.id]
                      : selectedFacility?.id),
                  ],
                },
              }),
            },
          },
          {
            api_chargerports: {
              api_chargersessions_aggregate: {
                count: {
                  filter: {
                    stop_at: {
                      _gte: getEpochLastDate(180).toString(),
                    },
                  },
                  predicate: {
                    _eq: 0,
                  },
                },
              },
            },
          },
        ],
      },
    },
  });

  const colors = ["indigo", "lightGreen", "lime", "#FFADAD"];

  //   useEffect(() => {
  //     if (
  //       data?.api_charger_aggregate &&
  //       data1?.api_charger_aggregate &&
  //       data2?.api_charger_aggregate &&
  //       data3?.api_charger_aggregate
  //     ) {
  //       console.log(data, data1, data2, data3);
  //     }
  //   }, [data, data1, data2, data3]);

  useEffect(() => {
    if (
      data?.api_charger_aggregate &&
      data1?.api_charger_aggregate &&
      data2?.api_charger_aggregate &&
      data3?.api_charger_aggregate
    ) {
      setChargerStatus([
        {
          heading: "Used Within 15 days",
          status: data?.api_charger_aggregate?.aggregate?.count ?? 0,
          table: data?.api_charger_aggregate?.nodes ?? [],
        },
        {
          heading: "Used Within 30 days",
          status: data1?.api_charger_aggregate?.aggregate?.count ?? 0,
          table: data1?.api_charger_aggregate?.nodes ?? [],
        },
        {
          heading: "Used Within 60 days",
          status: data2?.api_charger_aggregate?.aggregate?.count ?? 0,
          table: data2?.api_charger_aggregate?.nodes ?? [],
        },
        {
          heading: "Unused For Over 6 Months",
          status: data3?.api_charger_aggregate?.aggregate?.count ?? 0,
          table: data3?.api_charger_aggregate?.nodes ?? [],
        },
      ]);
    }
  }, [data, data1, data2, data3]);

  const [tab, setTab] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [tableData, setTableData] = useState(null);

  const openStatusModal = (e, d) => {
    setTab(d);
    setOpenModal(true);
  };

  function formatDate(date) {
    let dd = String(date.getDate()).padStart(2, "0");
    let mm = String(date.getMonth() + 1).padStart(2, "0"); // January is 0!
    let yyyy = date.getFullYear();
    let hh = String(date.getHours()).padStart(2, "0");
    let min = String(date.getMinutes()).padStart(2, "0");
    let ss = String(date.getSeconds()).padStart(2, "0");

    return `${dd}-${mm}-${yyyy} ${hh}:${min}:${ss}`;
  }

  const formateTableData = (toFormateData) => {
    const formateData = (content, type) => {
      const returnData = [];
      content?.forEach((item) => {
        item.api_chargerports.forEach((p) => {
          returnData.push({
            charger_name: item?.name,
            connector_id: p.connector_id,
            facility_name: item?.api_facility.name,
            last_updated_at: p.updated_at
              ? formatDate(new Date(p.updated_at))
              : "",
          });
        });
      });

      return returnData;
    };

    const headers = [
      { label: "charger", id: "charger_name" },
      { label: "connector id", id: "connector_id" },
      { label: "facility", id: "facility_name" },
      { label: "last updated at", id: "last_updated_at" },
    ];

    setTableData({
      type: "table",
      name: null,
      tabs: toFormateData.map((item) => ({
        name: item.heading,
        headers: headers,
        table_content: formateData(item.table, item.heading),
        count: item.table?.length ?? 0,
      })),
    });
  };

  useEffect(() => {
    if (chargerStatus?.length > 0) formateTableData(chargerStatus);
  }, [chargerStatus]);

  const handleExportExcel = () => {
    if (!tableData || !tableData?.tabs) return;

    const workbook = XLSX.utils.book_new();

    tableData?.tabs?.forEach((tab) => {
      if (tab.table_content.length > 0) {
        const filteredData = tab.table_content.map(
          ({ charger_name, connector_id, facility_name, last_updated_at }) => ({
            charger: charger_name,
            "connector id": connector_id,
            facility: facility_name,
            last_updated_at: last_updated_at,
          })
        );

        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        XLSX.utils.book_append_sheet(workbook, worksheet, tab.name);
      }
    });

    if (workbook.SheetNames.length > 0)
      XLSX.writeFile(workbook, `Charger_types.xlsx`);
  };

  return (
    <Grid
      item
      backgroundColor={boxColor}
      sx={{ borderRadius: "16px", marginBottom: "24px" }}
    >
      {chargerStatus && (
        <Box sx={{ padding: "20px" }}>
          <Typography
            variant="h5"
            component="h5"
            sx={{ marginBottom: "24px", fontWeight: "600", fontSize: "20px" }}
          >
            {t("chargerOperationStatus")}
          </Typography>
          <Grid container justifyContent="space-between">
            {chargerStatus?.map((item, index) => (
              <Grid
                item
                xs={2.3}
                sx={{
                  padding: "4px 7px",
                  justifyContent: "space-between",
                  borderLeft: `4px solid ${colors[index]}`,
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                key={`grid-${index}`}
                onClick={(e) => openStatusModal(e, index)}
              >
                <Typography
                  variant="overline"
                  component="span"
                  sx={{
                    marginRight: "15px",
                    lineHeight: "16px",
                    textTransform: "capitalize",
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#5C677D",
                  }}
                >
                  {item?.heading}
                </Typography>
                <Typography
                  variant="subtitle2"
                  component="span"
                  sx={{ fontWeight: "600", fontSize: "14px", color: "#001233" }}
                >
                  {item?.status}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
      {openModal && (
        <>
          <CustomModal
            open={openModal}
            onClose={() => setOpenModal(false)}
            bgColor="white"
            width="50vw"
            overflow="clip"
          >
            <Grid sx={{ paddingInline: "16px" }}>
              <CustomTabs
                formTabs={tableData?.tabs}
                tabValue={tab}
                handleTabChange={(e, newValue) => setTab(newValue)}
                showCount={true}
              />
            </Grid>
            <Grid container justifyContent="flex-start" m={2}>
              <ExportExcel key="10" onClick={handleExportExcel} />
            </Grid>
            <DynamicTable
              setSelectedData={setTab}
              tabValue={tab}
              searchedData={tableData?.tabs[tab]?.table_content}
              tabs={tableData?.tabs}
              maxHeight="calc(70vh - 145px)"
            />
          </CustomModal>
        </>
      )}
    </Grid>
  );
};

export default ChargerOperationStatus;
